export default __webpack_public_path__ + "static/media/mac3.7fa0e642.png";